import React from "react"

const eventStageLabels = {
  openingSoon: "Reg. opening soon",
  preRegistrationsOpen: "Pre-reg. open",
  sortPending: "Sort pending",
  registrationsOpen: "Reg. open",
  drawPending: "Draw pending",
  readyToPlay: "Ready to play",
  playing: "Event in progress",
  resultsPending: "Results pending",
  ended: "Event completed",
}

// A Sorting event, `{ category, programType }`: these categories register on the Sorting List first, pre-registration opens registration.
// A Tenis10 event never is one, whatever its category (Tudor, 2026-10-24), as the API decides it (common/eventRegistration isSortingEvent).
export const isSortingEvent = event => !event?.programType && ['gold', 'platinum', 'champions'].includes(event?.category)

export const eventStageLabel = stage =>
  Object.prototype.hasOwnProperty.call(eventStageLabels, stage)
    ? eventStageLabels[stage]
    : "Stage unavailable"

export default function EventStage({ stage, loading = false }) {
  return <div className="mb-2 text-sm-right">
    <small className="d-block text-muted">Event stage</small>
    <h4 className="mb-0">{loading ? "Loading..." : eventStageLabel(stage)}</h4>
  </div>
}
